module.exports = __webpack_public_path__ + "img/back-4-n-5d45eac4.png";